const SENSOR_ORDER = {
    'Sensitech / TempTale': 1,
    'Sensitech': 1,
    'Tive': 2,
    'ElPro': 3,
    'Tempmate': 4,
    'OnAsset': 5,
    'Trackonomy': 6,
    'Roambee': 7,
    'DeltaTrak': 8,
    'Cryopak': 9,
    'Adapt Ideations': 10,
    'Controlant': 11,
    'Spot see': 12,
    'ATI': 13,
    'Berlinger': 14,
    'Quake Global': 15,
    'Frigga': 20,
    'Fresh liance': 21,
    'Elitechlog': 80,
    'Ellab': 81,
    'Testo': 82,
    'SenseAware (FedEx)': 99,
};

const SENSORS_TO_HIDE = ['Cryoport'];

/**
 * Sorts and filters a list of sensors based on predefined business rules.
 * - Filters out sensors that should be hidden.
 * - Sorts sensors based on a custom order.
 * - Sensors not in the custom order list are sorted alphabetically at the end.
 * @param {Array<Object>} sensors - The array of sensor objects to process. Each object should have a `sensor_name` or `name` property.
 * @returns {Array<Object>} The processed list of sensors.
 */
export const processSensorList = (sensors) => {
    if (!sensors || sensors.length === 0) {
        return [];
    }

    const processedList = sensors
        // 1. Filter out sensors we want to hide
        .filter(sensor => !SENSORS_TO_HIDE.includes(sensor.sensor_name || sensor.name))
        // 2. Sort the remaining sensors
        .sort((a, b) => {
            const nameA = a.sensor_name || a.name;
            const nameB = b.sensor_name || b.name;

            const orderA = SENSOR_ORDER[nameA] || Infinity; // Sensors not in the list go to the end
            const orderB = SENSOR_ORDER[nameB] || Infinity;

            if (orderA === Infinity && orderB === Infinity) {
                // If both are not in our custom list, sort them alphabetically
                return nameA.localeCompare(nameB);
            }

            return orderA - orderB;
        });

    return processedList;
}; 